import React, { useEffect, useState } from "react";
import { FaHeart, FaHeartbeat, FaLocationArrow, FaStar } from "react-icons/fa";
import "../../HomeListing.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { ApiService } from "../../../Components/Services/apiServices";
import Skeleton from "react-loading-skeleton";
import { useWishlist } from "../../../Components/Context/WishlistContext";

const IMAGE_BASE_URL = "https://www.adminfamilyfun.jewelscraze.com/front/images/rooms/";
const ITEMS_PER_PAGE = 12;

const HomeListing = () => {
    const [userLocation, setUserLocation] = useState(null);
    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
    const [hovered, setHovered] = useState(false);

    const { wishlist, toggleWishlistItem, handleRemoveFromWishlist } = useWishlist();

    useEffect(() => {
        const fetchproperty = async () => {
            try {
                setLoading(true);
                const propertyData = await ApiService.Commanfetchrequest('properties');
                setProperties(propertyData);
            } catch (error) {
                console.log('Error while fetching:', error);
            } finally {
                setLoading(false);
            }
        };

        const getUserLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        setUserLocation({ latitude, longitude });
                    },
                    (error) => {
                        console.error("Geolocation error:", error);
                    }
                );
            } else {
                console.warn("Geolocation not supported.");
            }
        };


        fetchproperty();
        getUserLocation();

    }, []);


    const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
        const R = 6371;
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return d;
    };



    const handleShowMore = () => {
        setVisibleCount((prev) => prev + ITEMS_PER_PAGE);
    };


    const visibleProperties = properties.slice(0, visibleCount);

    return (
        <div className="container listings-container">
            {loading ? (
                <>
                    {[...Array(4)].map((_, index) => (
                        <div key={index} className="listing-card">
                            <div className="image-container">
                                <Skeleton height={200} />
                            </div>
                            <div className="listing-info">
                                <h3><Skeleton width={`80%`} /></h3>
                                <p><Skeleton width={`60%`} /></p>
                                <p><Skeleton width={`40%`} /></p>
                            </div>
                        </div>
                    ))}
                </>
            ) : (
                <>
                    {visibleProperties.map((property, index) => (
                        <div key={index} className="listing-card">
                            <div className="image-container">
                                <Link to={`/property-details/${property.room_name}`}>
                                    <Swiper
                                        modules={[Pagination]}
                                        spaceBetween={10}
                                        slidesPerView={1}
                                        pagination={{ clickable: true }}
                                    >
                                        {property.room_images && property.room_images.length > 0 ? (
                                            property.room_images.map((img, index) => (
                                                <SwiperSlide key={index}>
                                                    <img
                                                        src={`${IMAGE_BASE_URL}${img.room_images}`}
                                                        alt={`${property.room_name} - ${index}`}
                                                        className="listing-image"
                                                    />
                                                </SwiperSlide>
                                            ))
                                        ) : (
                                            <SwiperSlide>
                                                <img
                                                    src="/images/default-property.jpg"
                                                    alt="Default"
                                                    className="listing-image"
                                                />
                                            </SwiperSlide>
                                        )}
                                    </Swiper>
                                </Link>
                                <div
                                    className="wishlist-icon"
                                    style={{
                                        position: "absolute",
                                        top: "10px",
                                        right: "10px",
                                        zIndex: 10,
                                        cursor: "pointer",
                                        transition: "transform 0.2s ease",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                    onClick={() => toggleWishlistItem(property)}
                                >
                                    <FaHeart style={{
                                        color: wishlist.some((item) => item.room_name === property.room_name)
                                            ? "red"
                                            : "white", fontSize: "1.5rem"
                                    }} />
                                </div>
                            </div>
                            <div className="listing-info">
                                <h3>{property.room_name}</h3>
                                <p>{property.location}</p>
                                {userLocation && property.latitude && property.longitude ? (
                                    <>
                                        <FaLocationArrow className="star-icon" style={{ color: "red" }} />
                                        <a
                                            href={`https://www.google.com/maps/dir/?api=1&origin=${userLocation.latitude},${userLocation.longitude}&destination=${property.latitude},${property.longitude}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                textDecoration: 'none',
                                                color: hovered ? 'blue' : '#000',
                                                marginLeft: '5px',
                                                transition: 'color 0.2s ease',
                                            }}
                                            onMouseEnter={() => setHovered(true)}
                                            onMouseLeave={() => setHovered(false)}
                                        >
                                            {(() => {
                                                const distanceKm = getDistanceFromLatLonInKm(
                                                    userLocation.latitude,
                                                    userLocation.longitude,
                                                    parseFloat(property.latitude),
                                                    parseFloat(property.longitude)
                                                );
                                                return distanceKm < 1
                                                    ? `${Math.round(distanceKm * 1000)} m away`
                                                    : `${distanceKm.toFixed(1)} km away`;
                                            })()}
                                        </a>
                                    </>
                                ) : (
                                    <FaLocationArrow className="star-icon" style={{ color: "gray" }} />
                                )}

                                <p style={{ fontWeight: "700", }}><FaStar className="star-icon" /> 4.9</p>
                            </div>

                        </div>
                    ))}

                    {/* Show More Button */}
                    {visibleCount < properties.length && (
                        <div className="text-center mt-4">
                            <button className="btn btn-primary" onClick={handleShowMore}>
                                Show More
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default HomeListing;
